module.exports = __webpack_public_path__ + "img/goal02.7fbb7943.png";